import { jsx as _jsx } from "react/jsx-runtime";
import { TextAlpha, useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
import { generateTestId } from '../../util/TestUtil';
export const MenuSearchSectionTitle = ({ title, testId }) => {
    const isDesktop = useMediaQueryMatchesOnDesktop();
    return (_jsx(TextAlpha, { variant: isDesktop ? 'subheadingS' : 'eyebrowHeadingS', testId: generateTestId({ testId, suffix: 'section-label' }), color: isDesktop ? 'brand' : 'subtle', children: title }));
};
